import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Tool } from "src/app/models/Tool";

import { Basket } from "./../models/Enums";
import { CompanyService } from "./company.service";
import { StorageService } from "./storage.service";

export const BASKET_RA: string = "wimt-basket.ra";
export const BASKET_PO: string = "wimt-basket.po";

@Injectable({
  providedIn: "root",
})
export class BasketService {
  private toolsChangeSubject = new BehaviorSubject<Tool[]>(null);
  public toolsChange$ = this.toolsChangeSubject.asObservable();
  constructor(
    private basket: Basket,
    private companyService: CompanyService,
    public tools: Tool[],
    private storageService: StorageService,
  ) {}

  public add(tool: Tool): void {
    this.updateItem(tool);
  }

  public getAll(): Tool[] {
    const baskets = this.storageService.getBasket(this.basket);
    return (
      baskets?.filter((x: Tool) => x.companyId === this.companyService.selectedCompany?.name) ?? []
    );
  }

  public remove(tool: Tool): void {
    this.updateItem(tool);
  }

  private updateItem(tool: Tool) {
    if (this.isToolAlreadyInBasket(tool)) {
      this.tools = this.tools.filter(
        (x) => !(x.companyId === tool.companyId && x.toolId === tool.toolId),
      );
      if (this.tools.length === 0) {
        this.tools = null;
      }
    } else {
      if (!this.tools) {
        this.tools = [];
      }
      this.tools.push(tool);
    }

    this.storageService.setBasket(this.basket, this.tools);
    this.toolsChangeSubject.next(this.tools);
  }

  public persistCurrentBasket(): void {
    this.storageService.setBasket(this.basket, this.tools);
  }

  public cleanBasket() {
    this.storageService.clearBasket(this.basket);
    this.tools = null;
  }

  public isToolAlreadyInBasket(tool: Tool): boolean {
    const tools = this.getAll();
    return tools.some((x) => x.companyId === tool.companyId && x.toolId === tool.toolId);
  }

  public get itemsCount(): number {
    return this.getAll().length;
  }
}
